module.exports = __webpack_public_path__ + "img/Feature.fd512729.jpg";